import React from "react";
import { Link } from "react-router-dom";

export const CONTAINER = "max-w-7xl 2xl:max-w-[88rem] mx-auto px-4 sm:px-6 lg:px-10";

export const Section = ({ title, eyebrow, children, tone = "white" }) => (
  <section className={tone === "paper" ? "bg-paper-50" : "bg-white"}>
    <div className={`${CONTAINER} py-14 sm:py-20`}>
      {eyebrow && <p className="font-mono text-xs uppercase tracking-wider text-accent-600 mb-3">{eyebrow}</p>}
      {title && <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight max-w-3xl mb-8">{title}</h2>}
      {children}
    </div>
  </section>
);

export const PageHeader = ({ eyebrow, title, intro }) => (
  <div className="bg-paper-50 border-b border-paper-200">
    <div className={`${CONTAINER} py-14 sm:py-20`}>
      {eyebrow && <p className="font-mono text-xs uppercase tracking-wider text-accent-600 mb-3">{eyebrow}</p>}
      <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight max-w-3xl">{title}</h1>
      {intro && <p className="mt-5 text-lg text-ink-500 max-w-2xl">{intro}</p>}
    </div>
  </div>
);

const STATUS_STYLE = {
  Existing: "text-accent-600 border-accent-600",
  Planned: "text-ink-700 border-ink-300",
  "To be confirmed": "text-amber-800 border-amber-500",
};

export const StatusTag = ({ status }) => (
  <span className={`font-mono text-xs border rounded px-2 py-0.5 ${STATUS_STYLE[status] || STATUS_STYLE.Planned}`}>
    {status}
  </span>
);

export const CapabilityList = ({ items }) => (
  <ul className="divide-y divide-paper-200 border-y border-paper-200">
    {items.map((i) => (
      <li key={i.name} className="py-5 grid gap-2 sm:grid-cols-[16rem_1fr_auto] lg:grid-cols-[20rem_1fr_auto] sm:gap-8 items-start">
        <h3 className="font-semibold">{i.name}</h3>
        <p className="text-ink-500">{i.text}</p>
        <StatusTag status={i.status} />
      </li>
    ))}
  </ul>
);

export const ContactCta = ({ text = "Tell us about the problem you are trying to solve." }) => (
  <Section tone="paper">
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
      <p className="text-xl sm:text-2xl font-semibold max-w-xl">{text}</p>
      <Link to="/contact" className="inline-block px-6 py-3 bg-ink-900 text-white rounded hover:bg-ink-700 text-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-600">
        Discuss a project
      </Link>
    </div>
  </Section>
);
